import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { Store } from "@ngrx/store"
import moment from "moment"
import { NgxPopperjsPlacements, NgxPopperjsTriggers } from "ngx-popperjs"
import { Subject, takeUntil, tap } from "rxjs"
import * as fromStore from '@app/shared/store'
import { User } from "@app/shared"

type LogisticsData = {
  dispatcherTrips: {
    /** Totals doesn't have _id */
    _id?: string
    name: string
    ordersCount: number
    vehiclesCount: number
    avgBooking: number
    totalAmount: number
  }[]
  logisticsPerformance: {
    dispatcherId: string
    dispatcherName: string
    stats: {
      total: number
      origin: {
        early: number
        onTime: number
        late: number
        noDate: number
      }
      destination: {
        early: number
        onTime: number
        late: number
        noDate: number
      }
    }
  }[]
}

@Component({
    selector: "app-dashboard-logistic",
    templateUrl: "./dashboard-logistic.component.html",
    styleUrls: ["./dashboard-logistic.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DashboardLogisticComponent implements OnInit, OnDestroy {

  destroyed$ = new Subject<boolean>()

  placements = NgxPopperjsPlacements;
  triggers = NgxPopperjsTriggers;

  @Input({required: true})
  set data(val: LogisticsData) {
    if(val){
      this._data = val
    }
  }
  _data: LogisticsData
  get data(){
    return this._data
  }

  @Output()
  onUpdate = new EventEmitter<any>()

  defaultDate = {
    startDate: moment.utc().startOf('month').toISOString(),
    endDate: moment.utc().endOf('month').toISOString(),
    dataRange: 'thisMonth'
  }

  interval

  sortable = {
    sort: 'incr',
    field: 'name'
  }

  NgxPopperjsPlacements = NgxPopperjsPlacements
  NgxPopperjsTriggers = NgxPopperjsTriggers

  @Input({required: true})
  users: User[]
  @Input()
  filters: {[key: string]: any}


  constructor(
    private store: Store<fromStore.State>,
    private cdr: ChangeDetectorRef,
  ) {

  }

  ngOnInit() {
    this.interval = setInterval(() => {
      this.onUpdate.emit(this.filters)
    }, 18000 * 1000) // 30 minutes

    document.addEventListener('fullscreenchange', () => {
      this.isFullscreen = !!document.fullscreenElement
      this.cdr.detectChanges()
    })
  }

  toggleFullscreen() {
    const elem = document.documentElement;
    if (!document.fullscreenElement) {
      elem.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  }

  onSortDispatcherTrips( field, sort) {

    this.sortable = {
        sort,
        field
    }
    if (field == 'name') {
        if (this.sortable.sort == 'incr') {
            this.data.dispatcherTrips?.sort((a, b) => a.name.localeCompare(b.name))
        } else {
            this.data?.dispatcherTrips?.sort((a, b) => b.name.localeCompare(a.name))
        }
    } else {
        if (this.sortable.sort == 'incr') {
            this.data?.dispatcherTrips?.sort((a, b) => a[field] - b[field])
        } else {
            this.data?.dispatcherTrips?.sort((a, b) => b[field] - a[field])
        }
    }
    this.cdr.detectChanges()
  }

  isFullscreen = false;

  selectUser(event){
    this.onUpdate.emit({excludeIds: event})
  }

  excludeDispatcher(id: string, isTotals?: boolean) {
    if(isTotals) {
      this.filters = { ...this.filters, removeTotals: true };
    }else {
      this.filters.excludeIds = this.filters.excludeIds || []
      this.filters = { ...this.filters, excludeIds: [...this.filters.excludeIds, id] };
    }
    this.onUpdate.emit(this.filters)
  }

  showTotals() {
    delete this.filters.removeTotals
    this.onUpdate.emit(this.filters)
  }

  ngOnDestroy() {
    clearInterval(this.interval)
    this.destroyed$.next(true)
    this.destroyed$.complete()
  }
}
